import { Badge } from '@/components/atoms/badge';
import { cn } from '@/lib/utils';

interface SentimentTagPillsProps {
  tags?: string[];
  className?: string;
}

const PRETTY: Record<string, string> = {
  timeliness: 'Timeliness',
  pricing: 'Pricing',
  quality: 'Quality',
  tech_behavior: 'Tech behavior',
  scheduling: 'Scheduling',
  other: 'Other',
};

/**
 * Renders the §9.7 sentiment categories (or any platform-derived tags) as
 * a row of small chip badges. Returns null when there are no tags so callers
 * don't have to branch.
 */
export function SentimentTagPills({ tags, className }: SentimentTagPillsProps) {
  if (!tags?.length) return null;
  return (
    <div className={cn('flex flex-wrap gap-1', className)}>
      {tags.map((tag) => (
        <Badge key={tag} variant="secondary" className="text-[10px] px-1.5 py-0 h-5">
          {PRETTY[tag] ?? tag}
        </Badge>
      ))}
    </div>
  );
}
